import { useCallback } from 'react';
import { useAsyncState } from './hooks/useAsyncState';
export function createMutation(mutation, { injected, refetchResources, update }) {
    return {
        use: () => {
            const [state, { resolve, reject, pending }] = useAsyncState();
            const handleMutation = useCallback(async ({ input, optimisticResponse }) => {
                update && optimisticResponse && update(optimisticResponse);
                pending();
                try {
                    const { data, meta } = await mutation(input)(injected);
                    resolve(data, meta);
                    update && update(data);
                    refetchResources &&
                        refetchResources.forEach(resource => resource.clear());
                }
                catch (error) {
                    reject(error);
                }
            }, []);
            return [handleMutation, state];
        },
    };
}
//# sourceMappingURL=createMutation.js.map